import {useQuery} from '@tanstack/react-query';
import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_APPROVE_REJECT_API, RQ_DR_ALLOCATION_APPROVE_REJECT_API,
  RQ_DR_LEVEL_PLANNING_FETCH_API,
  RQ_ESCALATE_ALLOCATION_API,
  RQ_FETCH_DR_ALLOCATION_APPROVAL_API, RQ_FETCH_DR_ALLOCATION_APPROVAL_LIST_API,
  RQ_GET_BRAND_ALLOCATION_FOR_MANAGER_API,
  RQ_GET_BRAND_GROUP_LIST_API,
  RQ_GET_ESCALATION_LIST,
  RQ_RESUBMIT_ALLOCATION,
  RQ_SAVE_ALLOCATION_CHANGES_API,
  RQ_SAVE_BRAND_ALLOCATION_API,
  RQ_SAVE_DR_LEVEL_PLANNING_API,
  RQ_SUBMIT_DR_LEVEL_PLANNING_API,
} from '@app/reactQuery/apis/constants';

export const RQGetBrandGroupListAPI = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_brand_group_list_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_BRAND_GROUP_LIST_API,
        null,
        certificate,
        {locationId:locationId, yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};

export const RQSaveBrandAllocation = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SAVE_BRAND_ALLOCATION_API,
    JSON.stringify({...dto}),
    certificate,
    null,
    signal,
  );
};

export const RQGetBrandAllocationForManagerAPI = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_brand_allocation_for_manager_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, sapCode, employeeId, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_BRAND_ALLOCATION_FOR_MANAGER_API,
        null,
        certificate,
        {sapCode: sapCode, employeeId:employeeId, yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};

export const RQSaveAllocationChanges = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SAVE_ALLOCATION_CHANGES_API,
    JSON.stringify(dto),
    certificate,
    null,
    signal,
  );
};

export const RQApproveRejectAllocation = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_APPROVE_REJECT_API,
    JSON.stringify(dto),
    certificate,
    null,
    signal,
  );
};

export const RQEscalateAllocation = ({masterId, certificate, signal}) => {
  return rqCreateRequest(
    RQ_ESCALATE_ALLOCATION_API,
    null,
    certificate,
    {masterId: masterId},
    signal,
  );
};

export const RQGetEscalationAllocationListAPI = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_escalation_allocation_list_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, employeeId, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_ESCALATION_LIST,
        null,
        certificate,
        {employeeId:employeeId, yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};

export const RQResubmutAllocation = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RESUBMIT_ALLOCATION,
    JSON.stringify(dto),
    certificate,
    null,
    signal,
  );
};

export const RQGetDrPlanningListAPI = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_dr_planning_list_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_DR_LEVEL_PLANNING_FETCH_API,
        null,
        certificate,
        {locationId:locationId, yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};

export const RQSaveDrLevelAllocationChanges = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SAVE_DR_LEVEL_PLANNING_API,
    JSON.stringify(dto),
    certificate,
    null,
    signal,
  );
};

export const RQSubmitDrLevelAllocationChanges = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SUBMIT_DR_LEVEL_PLANNING_API,
    JSON.stringify(dto),
    certificate,
    null,
    signal,
  );
};

export const RQGetDrAllocationListAPI = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_dr_allocation_list_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, approverId, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_FETCH_DR_ALLOCATION_APPROVAL_LIST_API,
        null,
        certificate,
        {approverId: approverId, yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};

export const RQGetDrAllocationAPI = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_dr_allocation_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, approverId, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_FETCH_DR_ALLOCATION_APPROVAL_API,
        null,
        certificate,
        {locationId: locationId, approverId: approverId, yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};

export const RQDrAllocationApproveRejectAPI = ({dto, certificate, signal}) => {
  return rqCreateRequest(
    RQ_DR_ALLOCATION_APPROVE_REJECT_API,
    JSON.stringify(dto),
    certificate,
    null,
    signal,
  );
};
